import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF'

const RemarksModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // fields
    remarks, onRemarksChange, remarksError, setRemarksError,
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Add remarks'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextAreaSF type='text' name='remarks' label='Internal remarks'
      value={remarks} onChange={onRemarksChange}
      error={remarksError} setError={setRemarksError}
      help='500 characters max'
    />
  </ModalFormUI>

export default RemarksModalUI
